"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.sendContactForm.name': 'Formularz Kontaktowy',
    'tools.sendContactForm.description': 'Zbiera dane formularza kontaktowego (imię, email, telefon, wiadomość) z wiadomości użytkownika i wysyła zapytanie kontaktowe',
};
